import { register, getPrefix } from '../../../Utils'

const CongressHeader = el => {
  const prefix = getPrefix(el)
  let paused = false

  const observer = new IntersectionObserver(
    ([e]) => {
      if (!paused) {
        e.target.classList.toggle(`${prefix}is--sticky`, e.intersectionRatio < 1)
        paused = true
        setTimeout(() => {
          paused = false
        }, 400)
      }
    },
    { threshold: [1] }
  )

  observer.observe(el)
}

register('CongressHeader', CongressHeader)
